import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import RadioButton from "../../../../common/RadioButton";
import { LinkButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getHealthcareProxy,
  getHealthcareQuestionByCategory,
  postHealthcareProxy,
} from "../../../../services/documentServices";
import { QuestionByCategoryType } from "../../../../constants/constants";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Circle } from "@mui/icons-material";
import { Circles } from "react-loader-spinner";
import InputField from "../../../../common/InputField";
import { Form, Formik } from "formik";
const GuardianceAndAccountability = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [guardianceOrdinance, setGuardianOrdinance] = useState([]);
  const [validityBeyondDeath, setValidityBeyondDeath] = useState([]);
  const [accountability, setAccountability] = useState([]);
  const [insideBussiness, setInsideBussiness] = useState([]);
  const [data, setData] = useState([]);
  const [showNotes, setShowNotes] = useState(false);
  const [notes, setNotes] = useState({
    note: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad?.furtherRegulations?.length) {
          setNotes(result.payLoad?.furtherRegulations[0]);
          setShowNotes(true);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }


  async function fetchInsideBusiness() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.INSIDE_BUSINESS,
      id
    );
    if (result?.success) {
      setInsideBussiness(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }
  async function fetchGuardianceOrdinance() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.GUARDIAN_ORDIANCE,
      id
    );
    if (result?.success) {
      setGuardianOrdinance(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }
  async function fetchValidityBeyondDeath() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.VALIDITY_BEYOND_DEATH,
      id
    );
    if (result?.success) {
      setValidityBeyondDeath(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }
  async function fetchAccountability() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.ACCOUNTABLITIY,
      id
    );
    if (result?.success) {
      setAccountability(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }

  useEffect(() => {
    fetchData();
    fetchInsideBusiness()
    fetchGuardianceOrdinance();
    fetchValidityBeyondDeath();
    fetchAccountability();
  }, []);
  const setYes = (e, type) => {
    if (type === "guardiance-ordinance") {
      const updateList = {
        ...guardianceOrdinance,
        data: guardianceOrdinance?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: true,
            }
            : ele;
        })
      };
      setGuardianOrdinance(updateList);
    } else if (type === "validity-beyond-death") {
      const updateList = {
        ...validityBeyondDeath,
        data: validityBeyondDeath?.data?.map((ele) => {
          if (ele.questionType === 1) {
            return ele.id == e?.id
              ? {
                ...ele,
                yes: true,
              }
              : ele;
          } else {
            return ele.id == e?.id
              ? {
                ...ele,
                yes: true,
                answer: e?.date
              }
              : ele;
          }

        })
      }
      setValidityBeyondDeath(updateList);
    } else if (type === "accountability") {
      const updateList = {
        ...accountability,
        data: accountability?.data?.map((ele) => {
          return ele.id == e?.id
            ? {
              ...ele,
              yes: true,
            }
            : ele;
        })
      };
      setAccountability(updateList);
    } else if (type === "inside") {
      const updateList = {
        ...insideBussiness,
        data: insideBussiness?.data?.map((ele) => {
          return ele.id == e?.id ? { ...ele, yes: true } : ele;
        })
      }
      setInsideBussiness(updateList);
    }
  };
  const setNo = (e, type) => {
    if (type === "guardiance-ordinance") {
      const updateList = {
        ...guardianceOrdinance,
        data: guardianceOrdinance?.data?.map((ele) => {
          return ele.id == e?.id
            ? {
              ...ele,
              yes: false,
            }
            : ele;
        })
      }
      setGuardianOrdinance(updateList);
    } else if (type === "validity-beyond-death") {
      const updateList = {
        ...validityBeyondDeath,
        data: validityBeyondDeath?.data?.map((ele) => {
          if (ele?.questionType === 1) {
            return ele?.id == e?.id
              ? {
                ...ele,
                yes: false,
              }
              : ele;
          } else {
            return ele.id == e?.id
              ? {
                ...ele,
                yes: true,
                answer: e?.date
              }
              : ele;
          }

        })
      }
      setValidityBeyondDeath(updateList);
    } else if (type === "accountability") {
      const updateList = {
        ...accountability,
        data: accountability?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: false,
            }
            : ele;
        })
      };
      setAccountability(updateList);
    } else if (type === "inside") {
      const updateList = {
        ...insideBussiness,
        data: insideBussiness?.data?.map((ele) => {
          return ele.id == e.id ? { ...ele, yes: false } : ele;
        })
      };
      setInsideBussiness(updateList);
    }
  };

  const setAllTrue = (currentObj) => currentObj.yes == true;

  const handleSubmit = async () => {
    setButtonDisabled(true);
    const payload = {
      ...data,
      ...(showNotes && {
        furtherRegulations: [notes],
      }),
      healthProxyAnswers: [
        ...data.healthProxyAnswers,
        ...insideBussiness?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
        ...guardianceOrdinance?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
        ...validityBeyondDeath?.data?.map((item, index) => ({
          ...item,
          answer: index === 0 ? item.yes ? "yes" : item.yes == null ? null : "no" : item.answer,
        })),
        ...accountability?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),

      ],
      checkListTab5:
        guardianceOrdinance?.data?.every(setAllTrue) &&
          validityBeyondDeath?.data?.every(setAllTrue) &&
          accountability?.data?.every(setAllTrue) &&
          insideBussiness?.data?.every(setAllTrue)
          ? 2
          : 1,
    };
    const result = await postHealthcareProxy(payload, id);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  const handleClickNotes = () => {
    setShowNotes(true);
  };
  return (
    <Formik
      initialValues={{ place: '' }}
      enableReinitialize
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {(formik) => {
        return (
          <Form id="form_submit" onSubmit={formik.handleSubmit}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
            className="summary-table documents-card-height">

            {isLoading ? (
              <Box component="div" className="loader-container">
                <Circles color="#dfc8db" height={80} width={80} />{" "}
              </Box>
            ) : (
              <Box component="div" width="60%" className="medical-care-container">
                {" "}

                <Typography variant="p" fontWeight="bold" className="mt-5">
                  {t("inside-business-heading")}
                </Typography>
                <Box padding="0 2rem" component="div" className="section-1">
                  <Box component="div" className="sub-section-1">
                    <Typography variant="p" marginRight="1rem">
                      {t("YES")}
                    </Typography>
                    <Typography variant="p">{t("NO")}</Typography>
                  </Box>
                  <ol>
                    {insideBussiness?.data?.length > 0 && insideBussiness?.data?.map((elem, index) => {
                      return (
                        <li>
                          <Box component="div" key={index} className="sub-section-2">
                            <Typography variant="p" margin="0 0.5rem" width="80%">
                              {elem?.translationKey ? t(elem.translationKey) : ""}
                            </Typography>
                            <RadioButton
                              value="0"
                              theme="box"
                              paddingLeft="1rem"
                              checked={elem.yes}
                              onChange={() => {
                                setYes(elem, "inside");
                              }}
                            />
                            <RadioButton
                              value="1"
                              theme="box"
                              checked={!elem.yes && elem.yes != null}
                              onChange={() => {
                                setNo(elem, "inside");
                              }}
                            />
                          </Box>
                        </li>
                      );
                    })}
                  </ol>
                </Box>


                <Typography variant="p" fontWeight="bold" className="mt-5">
                  {" "}
                  {t(accountability?.title?.translationKey)}{" "}
                </Typography>{" "}
                <Box
                  padding="0 2rem"
                  component="div"
                  className="section-1"
                  style={{
                    width: "100%",
                  }}
                >
                  <ol>
                    {" "}
                    {accountability?.data?.length > 0 && accountability?.data?.map((elem, index) => {
                      return (
                        <>
                          {index === 0 && <>
                            <Box
                              component="div"
                              className="sub-section-1"
                            >
                              <Typography
                                variant="p"
                                marginRight="1rem"
                              >
                                {t("YES")}
                              </Typography>
                              {elem?.questionType !== 3 && <>
                                <Typography variant="p">
                                  {t("NO")}
                                </Typography>
                              </>
                              }
                            </Box>
                          </>
                          }
                          <li key={index}>
                            {" "}
                            <Box
                              component="div"
                              key={index}
                              className="sub-section-2"
                            >
                              <Typography variant="p" margin="0 0.5rem" width="80%">
                                {" "}
                                {elem?.translationKey
                                  ? t(elem.translationKey)
                                  : ""}{" "}
                              </Typography>{" "}
                              <div style={{ padding: "0 1rem" }}>

                                <RadioButton
                                  value="0"
                                  theme="box"
                                  paddingLeft="1rem"
                                  checked={elem.yes}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setYes(elem, "accountability");
                                    } else {
                                      setNo(elem, "accountability");
                                    }
                                  }}
                                />{" "}
                                <div type="hidden" style={{ paddingLeft: "1rem" }} />
                              </div>


                            </Box>{" "}
                          </li>{" "}
                        </>
                      );
                    })}{" "}
                  </ol>{" "}
                </Box>{" "}
                <Typography variant="p" fontWeight="bold" className="mt-5">
                  {" "}
                  {t(validityBeyondDeath?.title?.translationKey)}{" "}
                </Typography>{" "}
                <Box
                  padding="0 2rem"
                  sx={{
                    width: "100% !important",
                  }}
                  component="div"
                  className="section-1"
                  style={{
                    width: "100%",
                  }}
                >

                  <ol>
                    {" "}
                    {validityBeyondDeath?.data?.length > 0 &&
                      validityBeyondDeath?.data?.map((elem, index) => {
                        return (
                          <>
                            {index === 0 && <>
                              <Box
                                component="div"
                                className="sub-section-1"
                              >
                                <Typography
                                  variant="p"
                                  marginRight="1rem"
                                >
                                  {t("YES")}
                                </Typography>
                                {elem?.questionType !== 3 && <>
                                  <Typography variant="p">
                                    {t("NO")}
                                  </Typography>
                                </>
                                }
                              </Box>
                            </>
                            }
                            <li>
                              <Box
                                component="div"
                                key={index}
                                className="sub-section-2"
                              >
                                <Typography variant="p" margin="0 0.5rem" width="80%">
                                  {" "}
                                  {elem?.translationKey
                                    ? t(elem.translationKey)
                                    : ""}{" "}
                                </Typography>{" "}
                                {elem?.questionType === 4 && <>
                                  <InputField
                                    fillwidth
                                    transKey={'input-25'}
                                    variant="standard"
                                    placeholder="Karlsruhe, 15th March 2022"
                                    name="place"
                                    type="date"
                                    value={elem.answer}
                                    onChange={(newValue) => {
                                      setYes({ ...elem, date: newValue }, "validity-beyond-death");
                                      formik.setFieldValue("place", newValue);

                                    }}
                                    onFocus={(e) => (e.target.type = "date")}
                                    onKeyDown={(e) => {
                                      e.preventDefault()
                                    }}
                                  />
                                </>}{" "}
                                {elem?.questionType === 3 &&
                                  <div style={{ padding: "0 1rem" }}>
                                    {" "}
                                    <RadioButton
                                      value="1"
                                      theme="box"
                                      paddingLeft="1rem"
                                      checked={elem.yes}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setYes(elem, "validity-beyond-death");
                                        } else {
                                          setNo(elem, "validity-beyond-death");
                                        }
                                      }}

                                    />
                                    <div type="hidden" style={{ paddingLeft: "1rem" }} />
                                  </div>
                                }
                              </Box>{" "}
                            </li>{" "}
                          </>
                        );
                      })}{" "}
                  </ol>{" "}
                </Box>{" "}
                <Typography variant="p" fontWeight="bold" className="mt-5">
                  {" "}
                  {t(guardianceOrdinance?.title?.translationKey)}{" "}
                </Typography>{" "}
                <Box
                  padding="0 2rem"
                  component="div"
                  className="section-1"
                  style={{
                    width: "100%",
                  }}
                >
                  {/* <Box component="div" className="sub-section-1">
                    <Typography variant="p" marginRight="1rem">
                      {" "}
                      {t("YES")}{" "}
                    </Typography>{" "}
                    <Typography variant="p"> {t("NO")} </Typography>{" "}
                  </Box>{" "} */}
                  <ol>
                    {" "}
                    {guardianceOrdinance?.data?.length > 0 && guardianceOrdinance?.data?.map((elem, index) => {
                      return (
                        <li>
                          <Box component="div" key={index} className="sub-section-2">
                            <Typography variant="p" margin="0 0.5rem" width="100%">
                              {" "}
                              {elem?.translationKey
                                ? t(elem.translationKey)
                                : ""}{" "}
                            </Typography>{" "}
                            {elem?.questionType !== 0 && <>
                              <RadioButton
                                value="0"
                                theme="box"
                                paddingLeft="1rem"
                                checked={elem.yes}
                                onChange={() => {
                                  setYes(elem, "guardiance-ordinance");
                                }}
                              />{" "}
                              <RadioButton
                                value="1"
                                theme="box"
                                checked={!elem.yes && elem.yes != null}
                                onChange={() => {
                                  setNo(elem, "guardiance-ordinance");
                                }}
                              />{" "}
                            </>
                            }
                          </Box>{" "}
                        </li>
                      );
                    })}{" "}
                  </ol>{" "}
                </Box>{" "}


                <Typography variant="p" fontWeight="bold" className="mt-5">
                  {" "}
                  {t("further-regulation-heading")}{" "}
                </Typography>{" "}
                <Box
                  padding="0 2rem"
                  component="div"
                  className="representation-in-court-textarea"
                >
                  <Typography
                    sx={{
                      mt: 2,
                      display: "flex",
                    }}
                  >
                    {" "}
                    {showNotes ? (
                      <textarea
                        id="w3review"
                        name="w3review"
                        rows="4"
                        cols="50"
                        placeholder={t("please-add-note-here")}
                        defaultValue={notes.note}
                        onChange={(e) => {
                          setNotes({
                            ...notes,
                            note: e.target.value,
                          });
                        }}
                      />
                    ) : (
                      <SecondaryButton
                        title={
                          <>
                            <Typography
                              sx={{
                                fontWeight: 900,
                                fontSize: "1.5rem",
                                position: "absolute",
                                top: "-6%",
                                left: "7%",
                              }}
                            >
                              +
                            </Typography>{" "}
                            {t("add-note")}{" "}
                          </>
                        }
                        textTransform="initial"
                        fontWeight="normal"
                        bgColor="#E8D7E5"
                        borderRadius="40px"
                        padding="2px auto"
                        minWidth="200px"
                        border="none"
                        color="color.black"
                        hoverBgColor="#DEDEDE"
                        click={handleClickNotes}
                      />
                    )}{" "}
                  </Typography>{" "}
                </Box>{" "}
              </Box>
            )}{" "}
          </Form>
        );
      }}
    </Formik>
  );
};

export default GuardianceAndAccountability;
